import { render, staticRenderFns } from "./SigningProcedureFilingList.vue?vue&type=template&id=0bb001ce"
import script from "./SigningProcedureFilingList.vue?vue&type=script&lang=js"
export * from "./SigningProcedureFilingList.vue?vue&type=script&lang=js"
import style0 from "./SigningProcedureFilingList.vue?vue&type=style&index=0&id=0bb001ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports